module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-data-card-c2523f0c68cd2e97b1551db6b7c68563.png";